import api from './http'
import type { Notification, NotificationsResponse } from '@/types/notification'

export async function fetchNotifications(): Promise<NotificationsResponse> {
    const response = await api.get('/notifications', {
        params: {
            sort: ['createdAt:desc'],
            pagination: {
                page: 1,
                pageSize: 50,
            },
        },
    })
    return response.data
}

export async function markNotificationAsRead(notificationId: string): Promise<Notification> {
    const response = await api.put(`/notifications/${notificationId}/mark-as-read`, {
        data: {
            read: true,
        },
    })
    return response.data
}

export async function markAllNotificationsAsRead(): Promise<void> {
    await api.put('/notifications/mark-all-as-read')
}

export async function deleteNotification(notificationId: number): Promise<void> {
    await api.delete(`/notifications/${notificationId}`)
}
